import { RouteConfig } from 'vue-router'
import { PageNotFound } from 'kuaidong-component'

export const pageNotFoundRoute: RouteConfig = {
  path: '/:pathMatch(.*)*',
  name: 'page_not_found',
  component: PageNotFound,
  meta: {
    title: '天天跳绳',
  },
}

export const activityNotFoundRoute: RouteConfig = {
  path: '/activity/:pathMatch(.*)*',
  name: 'activity_not_found',
  component: PageNotFound,
  props: (route) => ({ ...route.query, ...route.params, text: '活动已结束' }),
  meta: {
    title: '天天跳绳',
  },
}

export default [activityNotFoundRoute, pageNotFoundRoute]
